// Filename: uisitemap.js
// Timestamp: 2017.11.19-13:43:30 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import uitagslist from './uitagslist.js'

// create list-mapping of link details for each top-level dir
// ```
// {
//   "/blog/": [
//      { url, title, description, date_published },
//      { url, title, description, date_published }],
//   "/links/": [
//      { url, title, description }],
//   "/site-map/": [
//      { url, title, description }]
// }
// ```
const getlinklistasmap = linkarr => linkarr.reduce((acc, link) => {
  const linkurl = link.url
  const linkurldir = linkurl === '/'
    ? linkurl
    : linkurl.startsWith('https://')
      ? linkurl.replace('https://', '').split(/(?!^)\//)[0]
      : linkurl.split(/(?!^)\//)[0] + '/'

  if (linkurl === '/')
    return acc

  acc[linkurldir]
    ? acc[linkurldir].push(link)
    : acc[linkurldir] = [link]

  return acc
}, {})

const xvnode = (sess, cfg, graph, node, pg, subj) => {
  const tags = cfg.h
  const { ul, li, frag, main, div, span, a } = tags
  const linkarr = subj.linkarr
  const linkmap = getlinklistasmap(linkarr)
  const linkmapkeys = Object.keys(linkmap).sort((keya, keyb) => (
    linkmap[keya].length === linkmap[keyb].length
      ? (keya > keyb ? 1 : -1)
      : linkmap[keya].length > linkmap[keyb].length ? -1 : 1))

  return (
    main(linkmapkeys.map(key => frag([
      div([
        a({
          href: linkmap[key][0].url,
          title: linkmap[key][0].description
        }, key),
        ' ',
        span(linkmap[key][0].header
          || linkmap[key][0].description)
      ]),
      linkmap[key].length > 1 && (
        ul(linkmap[key].slice(1).map(link => (
          li([
            a({
              href: link.url,
              title: link.header || link.description
            }, link.url.replace(/^https:\/\//, '')),
            link.tags &&
              uitagslist.xvnode(sess, cfg, graph, node, uitagslist, {
                tags: link.tags
              })
          ])
        )))
      )
    ]))))
}

export default {
  type: 'uisitemap',
  xvnode
}
